<div class="zn-modal-container">
  <div class="zn-modal-content">
    <div class="modal-header abp-modal-header">
      <div id="abp-modal-header" class="modal-header-title">
        <h3>{{ _configuration()?.title | abpLocalization }}</h3>
        @if (_configuration()?.subTitle || _configuration()?.subTitlePill) {
          <div class="zn-modal-subtitle-row">
            @if (_configuration()?.subTitle) {
              <h4>{{ _configuration()?.subTitle | abpLocalization }}</h4>
            }
            @if (_configuration()?.subTitlePill; as subTitlePill) {
              <zn-pill
                [label]="subTitlePill.label"
                [variant]="subTitlePill.variant ?? 'data'"
              ></zn-pill>
            }
          </div>
        }
      </div>
      <button type="button" aria-label="Close" (click)="dismiss()" class="btn-sm btn-close">
      </button>
    </div>
    <div id="abp-modal-body" class="modal-body">
      <ng-container *ngComponentOutlet="_configuration()?.component ?? null; inputs: _componentInputs()"></ng-container>
    </div>
    <div id="abp-modal-footer" class="modal-footer">
      <zn-button (keydown.escape)="dismiss()" (clicked)="dismiss()" type="secondary"
        [label]="_configuration()?.dismissLabel | abpLocalization"></zn-button>
      @if (_configuration()?.confirmLabel) {
        <zn-button [disabled]="!this.outlet().componentInstance.canSave() || loading()" (keydown.enter)="confirm()" (clicked)="confirm()"
          type="primary" [label]="_configuration()?.confirmLabel | abpLocalization" [loading]="loading()" [loadingIconPosition]="'left'"></zn-button>
      }
    </div>
  </div>
 
  @if(_configuration()?.asideConfig?.show) {
    <aside
      class="zn-modal-aside"
      [class.zn-modal-aside-custom]="_configuration()?.asideConfig?.component"
    >
      <h5>{{ _configuration()?.asideConfig?.title | abpLocalization }}</h5>
      @if (_configuration()?.asideConfig?.component; as asideComponent) {
        <div class="zn-modal-aside-content">
          <ng-container
            *ngComponentOutlet="asideComponent; inputs: _configuration()?.asideConfig?.inputs ?? {}"
          ></ng-container>
        </div>
      } @else {
        <ul>
          @for(item of _configuration()?.asideConfig?.data | keyvalue: originalOrder; track item.key) {
            <li>
              <strong class="aside-label">{{ item.key | abpLocalization }}</strong>
              <small class="aside-value">{{ item.value }}</small>
            </li>
          }
        </ul>
      }
    </aside>
  }
</div>
